import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=bdb419de&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=bdb419de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb419de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdb419de')) {
      api.createRecord('bdb419de', component.options)
    } else {
      api.reload('bdb419de', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=bdb419de&scoped=true&", function () {
      api.rerender('bdb419de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mirWXCsfmgie/JS/comp/GuestBox.vue"
export default component.exports